(() => {
  // Shopify applies collection sorting on the server; preserve explicit choices.
  const url = new URL(window.location.href);
  if (url.searchParams.get('sort_by')) return;

  // Keep filters, pagination, preview parameters, and the URL fragment intact.
  url.searchParams.set('sort_by', 'best-selling');
  window.location.replace(url.href);
})();
